module.exports = __webpack_public_path__ + "6d6315c92a0f0399b959f8ec04934416.pdf";